import { Input } from 'components/2-molecules/Inputs/Input';
import React from 'react';
interface DatePickerInputProps {
	value?: string;
	placeholder?: string;
	onFocus?: () => void;
	onChange?: () => void;
	onClick?: () => void;
	disabled?: boolean;
	error?: string;
}
const DatePickerInputRender: React.ForwardRefRenderFunction<HTMLInputElement, DatePickerInputProps> = (
	{ value, placeholder, onClick, onFocus, onChange, disabled, error },
	innerRef,
) => {
	return (
		<Input
			type="text"
			value={value}
			placeholder={placeholder}
			ref={innerRef}
			onFocus={onFocus}
			onChange={onChange}
			onClick={onClick}
			disabled={disabled}
			textLeft={true}
			errors={error ? [error] : undefined}
			button={{
				icon: 'kalender',
				ariaLabel: placeholder,
				append: false,
				onClick: onClick,
				type: 'button',
			}}
		/>
	);
};

export const DatePickerInput = React.forwardRef(DatePickerInputRender);
